export const COMMON_IMAGES = {
  logo: 'img/logo.webp',
  instagramLogo: 'img/insta.png',
  facebookLogo: 'img/fb.png',
};

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/lenseslight/',
  facebook: 'https://www.facebook.com/lightsennlenses',
};

export const FEATURED_IMAGES = [
  { name: 'Textures', url: 'img/banners/textures.webp' },
  { name: 'Silhouette', url: 'img/banners/silhouette.webp' },
  { name: 'Bird', url: 'img/banners/bird.webp' },
];
